import { FeedContentItemProps } from '@components/report/content-items/feed-content-item/FeedContentItem';

import { IGContentData, IGReportRes } from '@apis/orval/model';

import { FeedContentProps } from './FeedContent';

export class FeedContentAdapter {
	value: IGReportRes;
	constructor(obj: IGReportRes) {
		this.value = obj;
	}

	get feedContents() {
		return this.value?.content?.recent_feed_contents ?? [];
	}

	sortContents(contents: IGContentData[], sortBy: 'newest' | 'engagement') {
		if (sortBy === 'newest')
			return contents.sort(
				(a, b) =>
					new Date(b.upload_at ?? 0).getTime() - new Date(a.upload_at ?? 0).getTime(),
			);
		else if (sortBy === 'engagement')
			return contents.sort(
				(a, b) =>
					(b.like_count ?? 0) +
					(b.comment_count ?? 0) -
					(a.like_count ?? 0 + (a.comment_count ?? 0)),
			);

		return contents;
	}

	getFeedContentItemProps(feedContentData: IGContentData): FeedContentItemProps {
		return {
			outLink: feedContentData.content_link ?? undefined,
			imgSrc: feedContentData.content_img_link ?? undefined,
			likeCount: feedContentData.like_count ?? undefined,
			commentCount: feedContentData.comment_count ?? undefined,
			isLikeHidden: !!(
				feedContentData.is_like_count_private ||
				(feedContentData?.like_count && feedContentData?.like_count < 0)
			),
			isCommentHidden: !!(
				feedContentData.is_comment_count_private ||
				(feedContentData?.comment_count && feedContentData?.comment_count < 0)
			),
		};
	}

	adapt(sortBy: 'newest' | 'engagement'): FeedContentProps {
		return {
			items: this.sortContents(this.feedContents, sortBy).map((feedContentData) =>
				this.getFeedContentItemProps(feedContentData),
			),
		};
	}
}
